import React from 'react';
import { useBreathingRhythm, BreathingConfig, Phase } from '../../hooks/useBreathingRhythm';
import './BreathingExercise.css';


interface BreathingExerciseProps {
    config: BreathingConfig;
    onComplete: () => void;
    onCancel: () => void;
}

const BreathingExercise: React.FC<BreathingExerciseProps> = ({ config, onComplete, onCancel }) => {
    const { phase, cycleCount, isActive, handleStart, handleStop, getDuration } = useBreathingRhythm(config, onComplete);

    // Derived state for UI
    const getInstruction = (p: Phase) => {
        switch (p) {
            case 'inhale': return 'Вдох носом';
            case 'hold': return 'Задержите';
            case 'exhale': return 'Выдох ртом';
            case 'holdAfter': return 'Задержите';
            default: return 'Нажмите начать';
        }
    };

    const getScale = (p: Phase) => {
        switch (p) {
            case 'inhale': return 1;
            case 'hold': return 1;
            case 'exhale': return 0.4;
            case 'holdAfter': return 0.4;
            default: return 0.4;
        }
    };

    // Determine transition duration style
    const transitionDuration = (phase === 'inhale' || phase === 'exhale') ? getDuration(phase) : 0;

    return (
        <div className="breathing-exercise-container">
            <div className={`breathing-visual ${phase}`}>
                {/* Dust particles layer */}
                <div className="dust-particles-container">
                    {[...Array(80)].map((_, i) => {
                        const randomOffset = Math.random() * 50 - 25; // -25 to +25
                        const randomSize = 0.5 + Math.random(); // 0.5 to 1.5 scale
                        return (
                            <div
                                key={i}
                                className={`dust-particle color-${i % 4}`}
                                style={{
                                    '--angle': `${(i / 80) * 360 + randomOffset}deg`,
                                    '--delay': `${Math.random() * 0.5}s`,
                                    '--radius-offset': `${randomOffset}px`,
                                    '--size-scale': randomSize
                                } as React.CSSProperties}
                            />
                        );
                    })}
                </div>

                <div
                    className={`breathing-circle ${phase}`}
                    style={{
                        transform: `scale(${getScale(phase)})`,
                        transitionDuration: `${transitionDuration}s`
                    }}
                />
                <div className="breathing-instruction">
                    {isActive ? getInstruction(phase) : 'Нажмите начать'}
                </div>
            </div>

            <div className="breathing-controls">
                {!isActive ? (
                    <>
                        <button className="breathing-button secondary" onClick={onCancel}>
                            Назад
                        </button>
                        <button className="breathing-button" onClick={handleStart}>
                            Начать
                        </button>
                    </>
                ) : (
                    <button className="breathing-button secondary" onClick={handleStop}>
                        Стоп
                    </button>
                )}
            </div>

            {isActive && (
                <div style={{ marginTop: '20px', color: '#999', fontSize: '0.9rem' }}>
                    Цикл: {cycleCount + 1} / {config.cycles}
                </div>
            )}
        </div>
    );
};

export default BreathingExercise;
